import GrayHeaderCard from "../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import {TableCell, TableRow, Typography} from "@material-ui/core";
import SimpleTable from "../../../../../../../../shared/components/tables/simple-table/SimpleTable";
import {headCells} from "./ServiziTableHelper";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {formatMissingData} from "../../../../../../../../shared/utils/formatDataUtils";

const ServiziTable = (props) => {
    const tableRows = (
        <TableRow>
            <TableCell align='left' style={{paddingRight: "3em"}}>
                <Typography variant={"subtitle2"}>{props.tableData.descrizioneServizio}</Typography>
            </TableCell>
            {/*<TableCell align='left' style={{verticalAlign: 'top'}}>*/}
            {/*    <Typography variant={"h6"}>{formatMissingData(props.tableData.canoneUnitario)}</Typography>*/}
            {/*</TableCell>*/}
        </TableRow>
    )

    return (
        <GrayHeaderCard title={
            <Grid container justifyContent='space-between' alignItems='center'>
                <Typography variant='subtitle1'>{props.title}</Typography>
                {props.setOpenDetailsDialog ?
                    <Button color='primary'
                            onClick={() => props.setOpenDetailsDialog(true)}>Vedi i dettagli</Button>
                    : null
                }
            </Grid>
        }>
            <SimpleTable headCells={headCells} tableRows={tableRows} loading={props.loading}/>
        </GrayHeaderCard>
    )
}

ServiziTable.propTypes = {
    title: PropTypes.string.isRequired,
    tableData: PropTypes.shape({
        descrizioneServizio: PropTypes.string.isRequired,
        canoneUnitario: PropTypes.string
    }),
    loading: PropTypes.bool.isRequired
}

export default ServiziTable;